import { z } from "zod";

export const planningApplicationsFilterSchema = z.object({
  showResidential: z.boolean(),
  showCommercial: z.boolean(),
  showOther: z.boolean(),
  showBoundaries: z.boolean(),
  maxYear: z.number(),
  minSize: z.number(),
  enabledTypes: z.array(
    z.enum([
      "changeOfUse",
      "dischargeOfConditions",
      "eia",
      "fullApplication",
      "gpdr",
      "listedBuildings",
      "outline",
      "reservedMatters",
      "tpo",
      "uncategorised",
    ]),
  ),
  enabledStatuses: z.array(z.enum(["Approved", "Pending", "Rejected", "Unknown", "Withdrawn"])),
  description: z.string().describe("Filter by description (use quotes for exact match)"),
  showAppealed: z.boolean(),
});
